export const BUSINESS = {
  name: "JC Colors Remodeling LLC",
  phone: "913-244-4798",
  phoneHref: "tel:+19132444798",
  email: "jccolors@gmail.com",
  emailHref: "mailto:jccolors@gmail.com",
};

export const IMAGES = {
  heroExterior:
    "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/e3b4d7effa486987_df0bb15f-3b8a-4463-9ac7-7c5d10f669bb.jpeg",
  interior:
    "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/ada8829c79a1724f_fea4459e-98bb-4e0b-a121-48b00ed1b25c.jpeg",
  painterAtWork:
    "https://images.unsplash.com/photo-1789841417999-67a24a247c90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxpbnRlcmlvciUyMHJvb20lMjB3YWxsJTIwcGFpbnRpbmclMjBwcm9mZXNzaW9uYWwlMjBwYWludGVyfGVufDB8fHx8MTc5MTc2Mjc5NXww&ixlib=rb-4.1.0&q=85",
  drywall:
    "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/26351e250b9e27f8_7785ef33-78aa-4340-90c9-a6a94fb3882e.webp",
  exterior2:
    "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/2780a2a2f9464a3b_6bdcb9ca-8a81-4ecf-9164-8fdd842f80d5.jpeg",
  exterior3:
    "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/e82d229779e8173b_b6b282d1-6138-4165-ba7a-895b9b1601cd.jpeg",
};

export const EXTERIOR_GALLERY = [
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/e3b4d7effa486987_df0bb15f-3b8a-4463-9ac7-7c5d10f669bb.jpeg",
    alt: "Two-story Kansas City area home with windows masked off for exterior painting by JC Colors Remodeling",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/2780a2a2f9464a3b_6bdcb9ca-8a81-4ecf-9164-8fdd842f80d5.jpeg",
    alt: "Ladders set against prepped siding during an exterior house repaint",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/e82d229779e8173b_b6b282d1-6138-4165-ba7a-895b9b1601cd.jpeg",
    alt: "Exterior painting prep around a covered deck — windows taped and siding caulked",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/49cb740bbdfc1bd9_a8f451e2-f90d-4575-ac2e-6a3cc6b7146c.jpeg",
    alt: "Siding caulked and prepped for paint around an outdoor AC unit",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/75121ad7fc43622a_96f4bf5f-0427-4b92-b7fa-23bc5530cbf0.jpeg",
    alt: "Corner trim and downspout detailed during exterior painting prep",
  },
];

export const INTERIOR_GALLERY = [
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/ada8829c79a1724f_fea4459e-98bb-4e0b-a121-48b00ed1b25c.jpeg",
    alt: "Finished basement repaint by JC Colors Remodeling — gray walls, white trim and a black accent wall",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/a77ece01e4811412_2fd68202-b21f-414f-a83d-16d4de3c9c0e.jpeg",
    alt: "Basement bar cabinets and island painted black with a mosaic tile backsplash",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/8db4e88e1942ee9b_9e03611e-c09b-4580-bd3c-8a5efb9be532.jpeg",
    alt: "Basement wet bar and living area after interior painting in a Kansas City area home",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/677187a4ba64e3b8_ad8f72f5-d760-4383-af8a-93f237d7aa31.jpeg",
    alt: "Freshly painted basement room with crisp white doors and trim",
  },
];

export const DRYWALL_GALLERY = [
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/8d9aaaa1b1fa1395_45783d6d-5ae6-4ac9-ac13-779a7d2668fc.webp",
    alt: "Custom drywall media wall with recessed niches mid-finishing by JC Colors Remodeling",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/5131e9b6969ce48e_bd4fe241-e268-4e83-9d7d-33cd9dda660e.webp",
    alt: "Drywall seams taped and mudded during a basement finish in the Kansas City metro",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/1a13de5ad49a2b03_a531f0de-37f8-4ff9-80bb-f3daed02b3ac.webp",
    alt: "Drywall finishing in progress — skim-coated wall and ceiling seams",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/26351e250b9e27f8_7785ef33-78aa-4340-90c9-a6a94fb3882e.webp",
    alt: "Smooth finished drywall media wall, primed and paint-ready",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_jc-colors-metro/artifacts/c9624b12e57ac29b_45a7f441-a37a-4501-8276-fce8f9c89456.webp",
    alt: "Freshly finished drywall walls and ceiling, smooth and ready for paint",
  },
];

export const SERVICES = [
  {
    slug: "interior-painting",
    title: "Interior Painting",
    short:
      "Walls, ceilings, trim and doors — careful prep, clean lines and a finish that makes every room feel new.",
    image: IMAGES.interior,
    imageAlt:
      "Finished basement repaint by JC Colors Remodeling — gray walls, white trim and a black accent wall",
  },
  {
    slug: "exterior-painting",
    title: "Exterior Painting",
    short:
      "Siding, trim, doors and shutters — thorough prep and durable finishes built for Kansas City weather.",
    image: IMAGES.exterior2,
    imageAlt:
      "Ladders against prepped siding during an exterior repaint by JC Colors Remodeling",
  },
  {
    slug: "drywall-repair",
    title: "Drywall Repair & Finishing",
    short:
      "Holes, cracks, water damage and texture matching — smooth, paint-ready walls with no trace of the repair.",
    image: IMAGES.drywall,
    imageAlt:
      "Smooth finished drywall media wall by JC Colors Remodeling, primed and paint-ready",
  },
];

export const SERVICE_DETAILS = {
  "interior-painting": {
    metaTitle: "Interior Painting Services in Overland Park | JC Colors",
    metaDescription:
      "Interior painting services in Overland Park, KS and the KC metro — walls, ceilings, trim and careful prep. Get a free estimate from JC Colors.",
    eyebrow: "Interior Painting",
    h1a: "Interior painting that",
    h1b: "changes how a room feels.",
    intro: [
      "A fresh interior paint job is the fastest way to transform a home — but the difference between a good job and a great one is everything that happens before the first coat. JC Colors Remodeling LLC provides interior painting services in Overland Park, KS and across the Kansas City metro, with careful prep, tidy job sites and crisp, clean lines.",
      "We paint walls, ceilings, trim, baseboards, doors and accent walls in lived-in homes every week. Floors and furniture get protected, surfaces get properly sanded, patched, caulked and primed, and every project ends with a walkthrough so nothing gets missed.",
    ],
    included: [
      "Walls, ceilings and accent walls",
      "Trim, baseboards, doors and casing",
      "Drywall patching and texture blending before paint",
      "Sanding, caulking and priming for a lasting finish",
      "Color and sheen guidance for every room",
      "Full floor and furniture protection, cleaned up daily",
    ],
    closing:
      "Whether it's a single bedroom in Lenexa or a whole main floor in Overland Park, we approach every interior the same way: protect everything, prep thoroughly and leave lines worth looking at.",
    galleryTitle: "Recent interior work",
    galleryIntro:
      "Real photos from JC Colors Remodeling interior projects — walls, trim, doors and cabinetry finished in a Kansas City area basement remodel.",
    gallery: INTERIOR_GALLERY,
  },
  "exterior-painting": {
    metaTitle: "Exterior House Painting in Overland Park, KS | JC Colors",
    metaDescription:
      "Exterior house painting in Overland Park, KS and the Kansas City metro. Siding, trim and curb appeal that lasts. Free estimates from JC Colors.",
    eyebrow: "Exterior Painting",
    h1a: "Exterior painting built for",
    h1b: "Kansas City weather.",
    intro: [
      "Kansas City weather is hard on exteriors — humid summers, freezing winters and everything in between. A lasting exterior paint job starts long before the color goes on: washing, scraping, sanding, caulking and priming the surfaces that take the beating.",
      "JC Colors Remodeling LLC provides exterior house painting in Overland Park, KS, Olathe, Lenexa and Kansas City, MO. We paint siding, trim, fascia, soffits, doors and shutters, and we time the work around the weather so the finish cures the way it should.",
    ],
    included: [
      "Siding, trim, fascia and soffit painting",
      "Front doors, garage doors and shutters",
      "Power washing and surface preparation",
      "Scraping, sanding and caulking of failing areas",
      "Minor wood repair before coating",
      "Quality exterior paints rated for the Midwest climate",
    ],
    closing:
      "From mid-century ranches in Overland Park to two-stories in Olathe, we treat your home's exterior like the first impression it is — and back it with prep that makes the finish last.",
    galleryTitle: "Recent exterior work",
    galleryIntro:
      "Real job-site photos from JC Colors Remodeling exterior projects — masking, caulking and prep in progress before the finish coats go on.",
    gallery: EXTERIOR_GALLERY,
  },
  "drywall-repair": {
    metaTitle: "Drywall Repair & Finishing in Kansas City | JC Colors",
    metaDescription:
      "Drywall repair and finishing in the Kansas City metro — patches, cracks, water damage and smooth, paint-ready walls. Free estimates.",
    eyebrow: "Drywall Repair & Finishing",
    h1a: "Drywall repair you'll",
    h1b: "never know was there.",
    intro: [
      "Doorknob holes, settling cracks, water stains, popped nails — drywall damage is part of life in any home, and a bad patch stands out more than the damage did. JC Colors Remodeling LLC handles drywall repair and finishing across the Kansas City metro, including drywall finishing in Kansas City, MO for remodels and basements.",
      "Because we're painters too, every repair is finished with the final coat in mind: properly taped, floated, sanded and texture-matched so the wall reads as one smooth, paint-ready surface.",
    ],
    included: [
      "Hole, dent and crack repair of any size",
      "Water-damaged drywall cut-out and replacement",
      "Texture matching — knockdown, orange peel and smooth",
      "Corner bead and seam repair",
      "Full drywall finishing for remodels and basements",
      "Primed, paint-ready surfaces — and the paint to finish it",
    ],
    closing:
      "One patch or a whole basement finish — in Overland Park, Lenexa, Olathe or KCMO, the goal is always the same: you shouldn't be able to find the repair when we're done.",
    galleryTitle: "Recent drywall work",
    galleryIntro:
      "Real photos from a JC Colors Remodeling basement finish — taped and mudded seams, a custom media wall with recessed niches, and smooth paint-ready walls.",
    gallery: DRYWALL_GALLERY,
  },
};

export const CITIES = [
  {
    slug: "overland-park-ks",
    city: "Overland Park",
    state: "KS",
    metaTitle: "House Painters in Overland Park, KS | JC Colors Remodeling",
    metaDescription:
      "House painters in Overland Park, KS for interior, exterior and drywall projects. Free estimates from JC Colors Remodeling LLC.",
    headline: "Painters & drywall pros for Overland Park homes.",
    body: [
      "Overland Park homes run the gamut — mid-century ranches near downtown OP, two-story traditionals in established neighborhoods, and new construction pushing south. Each style asks something different of a painter, and JC Colors Remodeling LLC works in all of them as house painters in Overland Park, KS homeowners can call for interior rooms, full exteriors and everything in between.",
      "Interior painting services in Overland Park, KS often start with the walls themselves: settling cracks and nail pops are common in the area's housing stock, so drywall repair in Overland Park, KS is a natural companion to most paint projects we take on. Outside, exterior house painting in Overland Park, KS means siding and trim that can stand up to humid summers and hard freezes — which is why prep comes first on every job.",
    ],
  },
  {
    slug: "kansas-city-mo",
    city: "Kansas City",
    state: "MO",
    metaTitle: "Painters in Kansas City, MO | JC Colors Remodeling LLC",
    metaDescription:
      "Painters in Kansas City, MO for residential painting and drywall finishing. Free estimates from JC Colors Remodeling LLC.",
    headline: "Residential painting for Kansas City, MO homes.",
    body: [
      "Kansas City, MO has some of the metro's most character-rich housing — shirtwaists and colonials in Brookside and Waldo, post-war ranches in the Northland, and everything in between. Older homes reward careful work, and as painters in Kansas City, MO we spend as much time on prep as on paint: scraping, sanding and priming surfaces that have seen decades of seasons.",
      "Our residential painting services in Kansas City, MO cover interiors, exteriors, and the wall work underneath — including drywall finishing in Kansas City, MO for basement build-outs, remodels and repairs in older homes where walls rarely start out flat.",
    ],
  },
  {
    slug: "lenexa-ks",
    city: "Lenexa",
    state: "KS",
    metaTitle: "House Painters in Lenexa, KS | JC Colors Remodeling LLC",
    metaDescription:
      "House painters in Lenexa, KS — interior painting, exterior painting and drywall repair. Free estimates from JC Colors Remodeling.",
    headline: "Painting & drywall services in Lenexa, KS.",
    body: [
      "Lenexa has grown fast — established neighborhoods around Old Town and Sar-Ko-Par, plus newer builds near City Center — and house painters in Lenexa, KS need to be comfortable in both. JC Colors Remodeling LLC paints interiors and exteriors across Lenexa, from refreshing a main floor before a move-in to repainting exteriors on homes hitting the fifteen-year mark.",
      "Drywall work travels with us too: patches, cracks and texture matching for Lenexa homes, finished smooth and paint-ready.",
    ],
  },
  {
    slug: "olathe-ks",
    city: "Olathe",
    state: "KS",
    metaTitle: "Painting Contractors in Olathe, KS | JC Colors Remodeling",
    metaDescription:
      "Painting contractors serving Olathe, KS — interior, exterior and drywall services. Free estimates from JC Colors Remodeling LLC.",
    headline: "Painting contractors for Olathe, KS homes.",
    body: [
      "Olathe is one of the fastest-growing cities in Kansas, full of family neighborhoods and two-story homes that eventually need a refresh. As painting contractors serving Olathe, KS, JC Colors Remodeling LLC handles whole-home interior repaints, exterior siding and trim, and the drywall repair that comes with busy households — dents, dings and the occasional doorknob hole.",
      "Every Olathe project starts with a free estimate and a clear scope, so you know exactly what gets prepped, painted and finished before work begins.",
    ],
  },
];

export const HOME_FAQ = [
  {
    q: "Which areas do you serve?",
    a: "We work across the Kansas City metro, with most projects in Overland Park KS, Kansas City MO, Lenexa KS and Olathe KS. If you're nearby but outside those cities, call 913-244-4798 and ask.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Yes. Every project starts with a free estimate — call 913-244-4798 or send the estimate form and we'll talk through your space, your timeline and what the work involves.",
  },
  {
    q: "Can you repair drywall before painting?",
    a: "Yes — drywall repair and finishing is a core part of what we do. Holes, cracks, water damage and texture matching are all handled before the first coat goes on, so the finish reads as one smooth surface.",
  },
  {
    q: "How do I get started?",
    a: "Call 913-244-4798 or fill out the free estimate form on our contact page. Tell us about your project and we'll take it from there.",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Walkthrough & estimate",
    text: "We look at the space, talk through your goals and put together a clear, free estimate — no surprises later.",
  },
  {
    n: "02",
    title: "Prep & protect",
    text: "Floors, furniture and landscaping get protected. Surfaces get washed, scraped, sanded, patched and primed.",
  },
  {
    n: "03",
    title: "Paint & finish",
    text: "Clean lines, even coats and careful detail work — the part everyone sees, done the way prep makes possible.",
  },
  {
    n: "04",
    title: "Final walkthrough",
    text: "We walk the project with you, handle any touch-ups on the spot and leave the space cleaner than we found it.",
  },
];
